import styled from 'styled-components';

export const Container = styled.div`
  @media (max-width: 768px) {
    .flex-container {
      display: grid;
    }

    .w-50 {
      width: 100% !important;
      margin-bottom: 10px;
    }

    .col-md-6 {
      padding: 0px;
    }
  }

  @media (min-width: 769px) {
    .flex-container {
      display: flex;
      width: 100%;
    }
  }

  .row-equal-height {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
  }

  .row-equal-height > .col-md-6 {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .row-equal-height > .col-md-6 .flex-container {
    display: flex;
    gap: 15px;
    flex-wrap: wrap;
  }

  .card-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: #fff;
    border-radius: 8px;
    padding: 15px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    min-height: 200px;
  }
`;
